import classes from '@/utils/classes/classes'

export default function Separator({ className }: { className?: string }) {
  return (
    <div
      className={classes('bg-base-grey-100 h-[1px] w-full', className)}
    ></div>
  )
}
